import {i18nConvertNumberWithDecimals} from "../../utils";

/**
 * F25 (LPP-21950) — T2.60b, punto 6: resa delle percentuali nella governance sconto al banco.
 *
 * Il difetto: la dashboard e il form di modifica rendevano la percentuale con
 * `(v / 100).toFixed(2) + "%"`, che scrive **sempre** il punto come separatore decimale. Un operatore
 * italiano leggeva quindi `2.50%` dove tutto il resto della console (importi, soglie, range sconto)
 * gli mostra la virgola: sullo stesso numero convivevano due convenzioni, e su valori come `2.50` la
 * lettura più naturale in italiano è "duecentocinquanta".
 *
 * La regola sta in un modulo a parte perché è l'unica parte testabile dei due punti di resa (colonne
 * ag-grid e campi read-only sono presentazione), com'è già per `historyAmounts.ts` e `discount.ts`.
 *
 * La localizzazione passa da {@link i18nConvertNumberWithDecimals} (`../../utils`), che è il
 * formattatore dello stream pricing (usato da 24 file) e implementa esattamente il criterio: virgola
 * per l'italiano, punto per le altre lingue. Deliberatamente **non** si usa `LOCALES`/`Intl`: `LOCALES`
 * appartiene allo stream network e porta `en = "en-IN"`, difetto noto e fuori dal perimetro di questa
 * task (Defect separato).
 *
 * **Decimali ridondanti: restano.** Un valore tondo continua a rendersi `10,00%` e non `10%`, come
 * faceva `toFixed(2)`: questa task chiude un difetto di *separatore*, non rivede la resa. Ridurre i
 * decimali cambierebbe l'aspetto di tutte le righe della dashboard, che è una decisione di UI da
 * prendere altrove.
 */

/**
 * Percentuale in centesimi di punto → testo localizzato (`250` → `2,50%` in italiano, `2.50%` nelle
 * altre lingue).
 *
 * Restituisce stringa vuota su `null`/`undefined`: è il contratto dei due punti di resa che la usano
 * (colonne `discountMin`/`discountMax` della griglia e campi read-only del form di modifica), dove
 * l'assenza del valore deve lasciare la cella **vuota** e non mostrare un trattino o uno zero.
 */
export const formatDeskDiscountPercentage = (value: number | null | undefined): string =>
    value != null ? `${i18nConvertNumberWithDecimals((value / 100).toFixed(2))}%` : "";
